import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {DocumentsApiService} from '../../../services/api/documents-api.service';
import {FileModel, ISignersGuidsModel, SignersOrVisorsModel} from '../../../models/file.model';
import {HelpersService} from '../../../services/helpers.service';
import {MemberService} from '../../../services/member.service';
import {MemberModel} from '../../../models/user.model';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';
import { catchError, EMPTY, filter, Subscription, switchMap, tap } from 'rxjs';
import { AppContentDialogComponentMT } from '../../material/content-dialog/app-content-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContractAvatarsService } from '../../../modules/contracts/services/contract-avatar.service';
import { DialogsMTService } from '../../../services/modal/dialogs-mt.service';

@Component({
    selector: 'app-signers',
    templateUrl: './signers.component.html',
    styleUrls: ['./signers.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush
})
export class SignersComponent implements OnInit {
    @Input() public fileUkey!: string;
    @Input() public fileModel!: FileModel;
    @Input() public editPermission!: boolean;
    @Input() public signers: SignersOrVisorsModel[] = [];

    @Output() public updateEvent: EventEmitter<any> = new EventEmitter<any>();
    private subs:Subscription = new Subscription ()
    private contentDialogRef!:MatDialogRef<any>
    public allMembers: MemberModel[] = [];
    currentMember!: MemberModel;

    isLockButton = false;

    constructor(
        private cds:ChangeDetectorRef,
        protected documentApi: DocumentsApiService,
        public helper: HelpersService,
        protected memberService: MemberService,
        public alert: AlertService,
        public modalService: ModalService,
        public translate: TranslateService,
        public contractAvatarsService: ContractAvatarsService,
        private dialog: MatDialog,
        private dialogsMTService: DialogsMTService,
    ) {
    }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
        this.documentApi.getFileData(this.fileUkey ? this.fileUkey : this.fileModel.key)
        .pipe(
          tap(data=>this.handleNewDocData(data.document)),
          tap(data=>this.contractAvatarsService.getAvatars(data.signers.map(el=>el.user?.guid||''))))
        .subscribe((data) => this.getMembers(data.document.signers_guids));
        this.memberService.getCurrentMember().then(res => {
            this.currentMember = res;
        });
        this.setSubscriptions();
    }
    setSubscriptions() {
      this.subs.add(this.contractAvatarsService.bSubAvatarsReady.asObservable().subscribe(res=>res? this.cds.detectChanges() : null))
    }
    handleNewDocData(data:FileModel) {
      this.fileModel = data;
      this.cds.detectChanges()
    }
    prepareSigners(signersGuids:ISignersGuidsModel[]) {
      let newSignerGuids = signersGuids.map(el=>el.member_guid)
      let currentSignersGuids = this.signers.map(el=>el.member_guid)
      let addedSigners = signersGuids.filter(el=>currentSignersGuids.includes(el.member_guid) === false)
      addedSigners.forEach(el=>{
        let memberData = this.allMembers.find(member=>member.guid === el.member_guid)
        this.signers.push({...el, user:memberData})
      })
      this.signers = this.signers.filter(el=>newSignerGuids.includes(el.member_guid))
    }
    getMembers(signersGuids:ISignersGuidsModel[]): void {
        this.memberService.getAllMembers().then(res => {
          this.allMembers = res.filter(x => x.project_setting.observation_type !== 'blocked');
          this.prepareSigners(signersGuids)
          this.allMembers.forEach((el:any)=>el.computed_name = this.helper.fullName(el))
          this.allMembers.sort((a,b)=>(a?.computed_name||'')>(b?.computed_name||'')? 1 : -1)
            for (const element of this.signers) {
                this.allMembers = this.allMembers.filter(x => x.guid !== element.user?.guid||'');
            }
        });
    }

    addSigner(user: HTMLSelectElement): void {
        this.isLockButton = true;
        this.documentApi.addSigner(this.fileUkey ? this.fileUkey : this.fileModel.key, user.value).subscribe({
            next: res => {
               this.contractAvatarsService.getAvatars([user.value]).subscribe()
                this.contentDialogRef.close();
                this.isLockButton = false;
                this.prepareSigners(res.group.signers_guids)
                this.handleNewDocData(res.group)
                this.updateEvent.emit();
                this.allMembers = this.allMembers.filter(x => x.guid !== user.value);
            }, error: error => {
                this.alert.setAlert(error.message, 'blue');
                this.isLockButton = false;
            },
        });
    }

    deleteSigner(signer: SignersOrVisorsModel): void {
      this.dialogsMTService.confirmDialog({actionHeader: 'CONFIRM.HEADERS.DELETE',actionBody: 'CONFIRM.TEXT.DELETE_SIGNER' })
      .pipe(
        filter(res => res?.isConfirmed),
        switchMap(()=> this.documentApi.deleteSigner( this.fileUkey || this.fileModel.key, signer?.user?.guid||'').pipe(
          catchError(e => {
              this.alert.setAlert(e.message, 'blue');
              return EMPTY
            }))
        ),
        catchError(() => {
						return EMPTY
        }))
      .subscribe(res=>{
        this.prepareSigners(res.group.signers_guids)
        this.updateEvent.emit();
        signer.user? this.allMembers.unshift(signer.user) : null;
        this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'nd_color');
      })
    }
    openDialog(content: TemplateRef<any>,minWidth?:number,minHeight?:number) {
      this.contentDialogRef = this.dialog.open(AppContentDialogComponentMT,{panelClass:'signer-dialog',minHeight:minHeight,minWidth:minWidth})
      this.contentDialogRef.componentInstance.templateRef = content
    }
}
